export default __webpack_public_path__ + "static/media/DB_4.ae216116.png";